import React from 'react';
import PropTypes from 'prop-types';
import { SELECTED_MODIFIER } from '../constants';
import { CURRENCY_CLASSNAME } from './constants';

const CurrencySelect = ({ currency, currencies, handleOnChange }) => (
  <select className={`${CURRENCY_CLASSNAME}__select`} onChange={handleOnChange} value={currency}>
    {currencies.map(({ id, code, name }) => (
      <option
        key={id}
        value={code}
        className={`${CURRENCY_CLASSNAME}__select__option${
          code === currency ? SELECTED_MODIFIER : ''
        }`}>
        {name}
      </option>
    ))}
  </select>
);

CurrencySelect.propTypes = {
  currency: PropTypes.string.isRequired,
  currencies: PropTypes.array.isRequired,
  handleOnChange: PropTypes.func.isRequired
};

export default CurrencySelect;
